import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetEventsQuery } from '../../data/queries/get-events.query'
import { GetEventsCitiesQuery } from '../../data/queries/get-events-cities.query'
import { GetEventsTotalsQuery } from '../../data/queries/get-events-totals.query'
import {
  type EventsPageEntity,
  type EventsTotalsEntity,
  type SortByEntity,
  type SortOrderEntity
} from '../../data/entities/events.entity'
import { CombinedEventsToResponseMapper } from '../mappers/events.mappers'
import { type EventsResponse, type GetEventsParams } from '../models/events'

export class GetEventsInteractor {
  private readonly mapper = new CombinedEventsToResponseMapper()

  constructor(
    private readonly getEventsPage: GetInteractor<EventsPageEntity>,
    private readonly getEventsTotals: GetInteractor<EventsTotalsEntity>
  ) {}

  public async execute(params: GetEventsParams): Promise<EventsResponse> {
    const offset = (params.page - 1) * params.pageSize
    const sortBy = params.sortBy as SortByEntity
    const sortOrder = params.sortOrder as SortOrderEntity

    const [pageResult, totalsResult] = await Promise.all([
      params.viewType === 'events'
        ? this.getEventsPage.execute(
            new GetEventsQuery(
              params.fromDate,
              params.toDate,
              params.fromPrevious,
              params.toPrevious,
              sortBy,
              sortOrder,
              offset,
              params.pageSize,
              params.organization
            )
          )
        : this.getEventsPage.execute(
            new GetEventsCitiesQuery(
              params.fromDate,
              params.toDate,
              params.fromPrevious,
              params.toPrevious,
              sortBy,
              sortOrder,
              offset,
              params.pageSize,
              params.organization
            )
          ),
      this.getEventsTotals.execute(
        new GetEventsTotalsQuery(
          params.fromDate,
          params.toDate,
          params.fromPrevious,
          params.toPrevious,
          params.organization
        )
      )
    ])

    return this.mapper.map({ page: pageResult, totals: totalsResult })
  }
}
